import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  changeDateFormat,
  checkArray,
  decimalValue,
  parseStringToDate,
} from "../../../../../helpers";
import { addFinanceAccountDetails } from "../../../../../Redux/actions";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";

const Accounts = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { add_accounts_details } = useSelector((state) => state.settingReducer);
  const financeAcc = add_accounts_details?.data;
  let { id } = useParams();

  useEffect(() => {
    dispatch(addFinanceAccountDetails(`/${id}`));
  }, []);

  const getHeaderContainer = () => {
    const accPrefix = add_accounts_details?.data?.prefix ?? "";
    let res = null;
    if (accPrefix == "E01") {
      res = (
        <div class="row-fluid shifts">
          <ul class="ingredient-info edit-shift">
            <li>
              <label>Account ID</label>
              <div class="input-group col-md-7">
                <p>{financeAcc?.account_id}</p>
              </div>
            </li>
            <li>
              <label> {financeAcc?.finance_type?.name} Group</label>
              <div class="input-group col-md-7">
                <p> {financeAcc?.finance_group?.name}</p>
              </div>
            </li>
            <li>
              <label> {financeAcc?.finance_type?.name} Account</label>
              <div class="input-group col-md-7">
                <p> {financeAcc?.name}</p>
              </div>
            </li>
            <li>
              <label>Shared Issued</label>
              <div class="input-group col-md-7">
                <p> {decimalValue("0", 2, add_accounts_details?.currency)}</p>
              </div>
            </li>
            <li>
              <label>Par Value Per Share</label>
              <div class="input-group col-md-7">
                {financeAcc?.par_value &&
                parseFloat(financeAcc?.par_value) > 0 ? (
                  decimalValue(
                    financeAcc?.par_value,
                    2,
                    add_accounts_details?.currency
                  )
                ) : (
                  <input
                    className="required"
                    type="text"
                    value={financeAcc?.par_value}
                  />
                )}
              </div>
            </li>
          </ul>
          {financeAcc?.par_value <= 0 && (
            <div class="btns col-4 d-flex justify-content-start py-4 col-12">
              <input type="button" value="Submit" id="submitBut" class="m-0" />
            </div>
          )}
        </div>
      );
    } else if (accPrefix == "E01") {
      res = (
        <div class="row-fluid shifts">
          <ul class="ingredient-info edit-shift">
            <li>
              <label>Account ID</label>
              <div class="input-group col-md-7">
                <p>{financeAcc?.account_id}</p>
              </div>
            </li>
            <li>
              <label> {financeAcc?.finance_type?.name} Group</label>
              <div class="input-group col-md-7">
                <p>{financeAcc?.finance_group?.name}</p>
              </div>
            </li>
            <li>
              <label>{financeAcc?.finance_type?.name} Account</label>
              <div class="input-group col-md-7">
                <p>{financeAcc?.name}</p>
              </div>
            </li>
            <li>
              <label class="required">Default Payment Acct.</label>
              <div class="input-group select-div col-md-7">
                <select
                  name="default_payment_account_id"
                  id="default_payment_account_id"
                  className="required"
                >
                  <option value={""}>Select</option>
                  {checkArray(add_accounts_details?.default_payment_accounts) &&
                    add_accounts_details?.default_payment_accounts.map(
                      (defaultPay) => {
                        <option value={defaultPay?.id}>
                          {defaultPay?.name}
                        </option>;
                      }
                    )}
                </select>
                {/* <?php echo $this->Form->input('FinanceAccount.default_payment_account_id', array('class' => 'required', 'type' => 'select', 'empty' => 'Select',
              'options' => $default_payment_accounts, 'value'=>$data['FinanceAccount']['default_payment_account_id']))?> */}
              </div>
            </li>
          </ul>

          <div class="btns col-4 d-flex justify-content-start py-4 col-12">
            <input type="button" value="Apply" id="applyBut" />
            <input type="button" value="Submit" id="submitBut" class="m-0" />
          </div>
        </div>
      );
    } else {
      res = (
        <ul class="ingredient-info edit-shift">
          <li>
            <label>Account ID</label>
            <div class="input-group col-md-7">
              <p>{financeAcc?.account_id}</p>
            </div>
          </li>
          <li>
            <label> Parent Account</label>
            <div class="input-group col-md-7">
              <p>{add_accounts_details?.parentAccount?.name ?? ""}</p>
            </div>
          </li>
          <li>
            <label>{financeAcc?.finance_type?.name ?? ""} Account</label>
            <div class="input-group col-md-7">
              <p>{financeAcc?.name ?? ""}</p>
            </div>
          </li>
        </ul>
      );
    }
    return res;
  };

  const addSubAccountHandler = () => {
    history.push(`/settings/finance/chart-of-accounts/addSubAccount/${id}`);
  };
  const editSubAccountHandler = (subId) => {
    history.push(`/settings/finance/chart-of-accounts/subAccounts/${subId}`);
  };

  const getBodyContainer = () => {
    let res = null;
    const accPrefix = financeAcc?.prefix ?? "";
    if (accPrefix == "L01") {
      res = (
        <div class="inner-space screen-scroll">
          <div className="table-responsive">
            <table
              width="100%"
              cellspacing="0"
              cellpadding="0"
              style={{ marginBottom: "0!important" }}
              class="checklist-table tableSec"
              filterBy="#HistorySearchTag"
            >
              <thead>
                <tr>
                  <th>Sub-Account ID</th>
                  <th>Sub-Account Name</th>
                  <th>Outstanding Balance</th>
                  <th>30-Day Aged Balance</th>
                  <th>60-Day Aged Balance</th>
                  <th>90-Day+ Aged Balance</th>
                  <th class="hide-small"> </th>
                  <th class="hide-small"> </th>
                </tr>
              </thead>
              <tbody>
                {checkArray(add_accounts_details?.subAccounts) &&
                  add_accounts_details?.subAccounts.map((subAccount) => {
                    return (
                      <tr>
                        <td>{subAccount?.account_id}</td>
                        <td>{subAccount?.name}</td>
                        <td>
                          {decimalValue(
                            subAccount?.current_balance,
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td>
                          {decimalValue(
                            subAccount?.["thirty_days"],
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td>
                          {decimalValue(
                            subAccount?.["sixty_days"],
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td>
                          {decimalValue(
                            subAccount?.["ninety_days'"],
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td class="hide-small" width="8%">
                          {" "}
                        </td>
                        <td className="action-td">
                          <a
                            class="circle_icon pull-right"
                            onClick={() =>
                              editSubAccountHandler(subAccount?.id)
                            }
                          >
                            <i class="iconSprites edit-icon">
                              <div class="tooltip-sm"> Edit </div>
                            </i>
                          </a>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div class="my-3">
            <button
              class="btn green-btn-revert add-plus addSp"
              id="addCount"
              type="button"
              onClick={() => addSubAccountHandler()}
            >
              <i class="i-icon"> </i> Add Sub Accounts
            </button>
          </div>
        </div>
      );
    } else if (accPrefix == "L04" || accPrefix == "L05") {
      res = (
        <div class="inner-space screen-scroll">
          <div className="table-responsive">
            <table
              width="100%"
              cellspacing="0"
              cellpadding="0"
              style={{ marginBottom: "0!important" }}
              class="checklist-table tableSec"
              filterBy="#HistorySearchTag"
            >
              <thead>
                <tr>
                  <th class="second-th" width="">
                    <a href="#_" class="ajaxPageSortFood asc">
                      {" "}
                      Debt ID
                    </a>
                  </th>
                  <th>Status</th>
                  <th>Liability Name</th>
                  <th>Outstanding Amount</th>
                  <th>Total Payments</th>
                  <th>Interest Accured</th>
                  <th>Initial Principle Account</th>
                  <th class="hide-small"> </th>
                  <th class="hide-small"> </th>
                </tr>
              </thead>
              <tbody>
                {checkArray(add_accounts_details?.subAccounts) &&
                  add_accounts_details?.subAccounts.map((subAccount) => {
                    return (
                      <tr>
                        <td width="15px" class="invent-first-col">
                          <a
                            onClick={() =>
                              editSubAccountHandler(subAccount?.id)
                            }
                          >
                            {subAccount?.editable == 1 ? (
                              <i class="edit-icon"></i>
                            ) : (
                              <i class="eye-icon"></i>
                            )}
                          </a>
                        </td>
                        <td>{subAccount?.account_id}</td>
                        <td>Open</td>
                        <td>{subAccount?.name}</td>
                        <td>
                          {decimalValue(
                            subAccount?.outstanding_amount,
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td>
                          {decimalValue(
                            subAccount?.total_payments,
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td>
                          {decimalValue(
                            subAccount?.insert_accured,
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td>
                          {decimalValue(
                            subAccount?.initial_principle_amount,
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td class="hide-small" width="8%">
                          {" "}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div class="my-3">
            <button
              class="btn green-btn-revert add-plus addSp"
              id="addCount"
              type="button"
              onClick={() => addSubAccountHandler()}
            >
              <i class="i-icon"> </i> Add Sub Accounts
            </button>
          </div>
        </div>
      );
    } else if (accPrefix == "A01" || accPrefix == "A08") {
      res = (
        <div class="inner-space screen-scroll">
          <div className="action-td">
            <table
              width="100%"
              cellspacing="0"
              cellpadding="0"
              style={{ marginBottom: "0!important" }}
              class="checklist-table tableSec"
              filterBy="#HistorySearchTag"
            >
              <thead>
                <tr>
                  <th>Sub-Account ID</th>
                  <th>Sub-Account Name</th>
                  <th>Current Balance</th>
                  <th>linked Payment Method</th>
                  <th>Default Deposit Account</th>
                  <th className="action-td">Action</th>
                </tr>
              </thead>
              <tbody>
                {checkArray(add_accounts_details?.subAccounts) &&
                  add_accounts_details?.subAccounts.map((subAccount) => {
                    return (
                      <tr>
                        <td>{subAccount?.account_id}</td>
                        <td>{subAccount?.name}</td>
                        <td>
                          {" "}
                          {decimalValue(
                            subAccount?.current_balance,
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>

                        <td>{subAccount?.methods}</td>
                        <td>{subAccount?.default_deposit?.name ?? ""}</td>

                        <td className="action-td">
                          <a
                            class="circle_icon pull-right"
                            onClick={() =>
                              editSubAccountHandler(subAccount?.id)
                            }
                          >
                            <i class="iconSprites edit-icon">
                              <div class="tooltip-sm"> Edit </div>
                            </i>
                          </a>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div class="my-3">
            <button
              class="btn green-btn-revert add-plus addSp"
              id="addCount"
              type="button"
              onClick={() => addSubAccountHandler()}
            >
              <i class="i-icon"> </i> Add Sub Accounts
            </button>
          </div>
        </div>
      );
    } else if (accPrefix == "A04" || accPrefix == "A07" || accPrefix == "A17") {
      res = (
        <div class="inner-space screen-scroll">
          <table
            width="100%"
            cellspacing="0"
            cellpadding="0"
            style={{ marginBottom: "0!important" }}
            class="checklist-table tableSec"
            filterBy="#HistorySearchTag"
          >
            <thead>
              <tr>
                <th width="35px">
                  <a class="mx-a" onClick={() => addSubAccountHandler()}>
                    <img src="/img/plus-small.svg" alt="" />
                  </a>
                </th>
                <th class="second-th" width="">
                  <a href="#_" class="ajaxPageSortFood asc">
                    {" "}
                    Investment ID
                  </a>
                </th>
                <th>Status</th>
                <th>Investment Name</th>
                <th>Current Value</th>
                <th>Unrealized P&L</th>
                <th>Relized P&L</th>
                <th>Purchase Value</th>
                <th class="hide-small"> </th>
                <th class="hide-small"> </th>
              </tr>
            </thead>
            <tbody>
              {checkArray(add_accounts_details?.subAccounts) &&
                add_accounts_details?.subAccounts.map((subAccount) => {
                  return (
                    <tr>
                      <td width="15px" class="invent-first-col">
                        <a
                          onClick={() => editSubAccountHandler(subAccount?.id)}
                        >
                          <i class="edit-icon"></i>
                        </a>
                      </td>
                      <td>{subAccount?.account_id}</td>
                      <td>Open</td>
                      <td>{subAccount?.name}</td>
                      <td>
                        {decimalValue(
                          subAccount?.current_value,
                          2,
                          add_accounts_details?.currency
                        )}
                      </td>
                      <td>
                        {decimalValue(
                          subAccount?.unrealized_pl,
                          2,
                          add_accounts_details?.currency
                        )}
                      </td>
                      <td>
                        {decimalValue(
                          subAccount?.realized_pl,
                          2,
                          add_accounts_details?.currency
                        )}
                      </td>
                      <td>
                        {decimalValue(
                          subAccount?.realized_pl,
                          2,
                          add_accounts_details?.currency
                        )}
                      </td>
                      <td class="hide-small" width="8%">
                        {" "}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      );
    } else if (accPrefix == "A05") {
      res = (
        <div class="inner-space screen-scroll">
          <table
            width="100%"
            cellspacing="0"
            cellpadding="0"
            style={{ marginBottom: "0!important" }}
            class="checklist-table tableSec"
            filterBy="#HistorySearchTag"
          >
            <thead>
              <tr>
                <th width="35px">
                  {financeAcc?.level != 2 && (
                    <a class="mx-a" onClick={() => addSubAccountHandler()}>
                      <img src="/img/plus-small.svg" alt="" />
                    </a>
                  )}
                </th>
                <th class="second-th" width="">
                  <a href="#_" class="ajaxPageSortFood asc">
                    {" "}
                    Asset ID
                  </a>
                </th>
                <th>Asset Name</th>
                <th>Current Value</th>
                <th>Accum. Depreciation</th>
                <th>Purchase Value</th>
                <th>Purchase Date</th>
                <th class="hide-small"> </th>
                <th class="hide-small"> </th>
              </tr>
            </thead>
            <tbody>
              {checkArray(add_accounts_details?.subAccounts) &&
                add_accounts_details?.subAccounts.map((subAccount) => {
                  return (
                    <tr>
                      <td width="15px" class="invent-first-col">
                        {subAccount?.subaccount_count > 0 ? (
                          <a
                            onClick={() =>
                              editSubAccountHandler(subAccount?.id)
                            }
                          >
                            <i class="edit-icon"></i>
                          </a>
                        ) : (
                          <a
                            onClick={() =>
                              editSubAccountHandler(subAccount?.id)
                            }
                          >
                            <i class="edit-icon"></i>
                          </a>
                        )}
                      </td>
                      <td>{subAccount?.account_id}</td>
                      <td>{subAccount?.name}</td>
                      <td>
                        {decimalValue(
                          subAccount?.current_value,
                          2,
                          add_accounts_details?.currency
                        )}
                      </td>
                      <td>
                        {decimalValue(
                          subAccount?.depreciation,
                          2,
                          add_accounts_details?.currency
                        )}
                      </td>
                      <td>
                        {decimalValue(
                          subAccount?.purchase_values,
                          2,
                          add_accounts_details?.currency
                        )}
                      </td>
                      <td>
                        {changeDateFormat(subAccount?.created, "MM/DD/yyyy")}
                      </td>
                      <td class="hide-small" width="8%">
                        {" "}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      );
    } else if (accPrefix == "A06") {
      res = (
        <div class="inner-space screen-scroll">
          <table
            width="100%"
            cellspacing="0"
            cellpadding="0"
            style={{ marginBottom: "0!important" }}
            class="checklist-table tableSec"
            filterBy="#HistorySearchTag"
          >
            <thead>
              <tr>
                <th width="35px">
                  <a class="mx-a" onClick={() => addSubAccountHandler()}>
                    <img src="/img/plus-small.svg" alt="" />
                  </a>
                </th>
                <th class="second-th" width="">
                  <a class="ajaxPageSortFood asc"> Deposit ID</a>
                </th>
                <th>Deposit Name</th>
                <th>Deposit Amount</th>
                <th>Deposit Date</th>
                <th>Returned Amount</th>
                <th>Returned Date</th>
                <th class="hide-small"> </th>
                <th class="hide-small"> </th>
              </tr>
            </thead>
            <tbody>
              {checkArray(add_accounts_details?.subAccounts) &&
                add_accounts_details?.subAccounts.map((subAccount) => {
                  return (
                    <tr>
                      <td width="15px" class="invent-first-col">
                        <a
                          onClick={() => editSubAccountHandler(subAccount?.id)}
                        >
                          <i class="edit-icon"></i>
                        </a>
                      </td>
                      <td>{subAccount?.account_id}</td>
                      <td>{subAccount?.name}</td>
                      <td>
                        {decimalValue(
                          subAccount?.current_balance,
                          2,
                          add_accounts_details?.currency
                        )}
                      </td>
                      <td>
                        {" "}
                        {changeDateFormat(subAccount?.created, "MM/DD/yyyy")}
                      </td>
                      <td>$0.00</td>
                      <td></td>
                      <td class="hide-small" width="8%">
                        {" "}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      );
    } else if (accPrefix == "E01") {
      res = (
        <div class="inner-space screen-scroll">
          <div className="table-responsive">
            <table
              width="100%"
              cellspacing="0"
              cellpadding="0"
              style={{ marginBottom: "0!important" }}
              class="checklist-table tableSec"
              filterBy="#HistorySearchTag"
            >
              <thead>
                <tr>
                  <th>Issuance ID</th>
                  <th>Issuance Name</th>
                  <th>Shares Issued</th>
                  <th>Issunce Amount</th>
                  <th>Common Stock</th>
                  <th>Paid in Capital</th>
                  <th>Issuance Date</th>
                  <th class="hide-small"> </th>
                  <th class="hide-small"> </th>
                  <th class="action-td">Action </th>
                </tr>
              </thead>
              <tbody>
                {checkArray(add_accounts_details?.subAccounts) &&
                  add_accounts_details?.subAccounts.map((subAccount) => {
                    return (
                      <tr>
                        <td>{subAccount?.account_id}</td>
                        <td>{subAccount?.name}</td>
                        <td>{subAccount?.purchase_value}</td>
                        <td>
                          {decimalValue(
                            subAccount?.current_balance,
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td>
                          {decimalValue(
                            subAccount?.common_stock,
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td>
                          {decimalValue(
                            subAccount?.paid_in_capital,
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td>
                          {changeDateFormat(subAccount?.created, "MM/DD/yyyy")}
                        </td>
                        <td class="hide-small"> </td>
                        <td class="hide-small"> </td>
                        <td class="hide-small" width="8%">
                          {" "}
                        </td>
                        <td className="action-td">
                          <a
                            class="circle_icon pull-right"
                            onClick={() =>
                              editSubAccountHandler(subAccount?.id)
                            }
                          >
                            <i class="iconSprites edit-icon">
                              <div class="tooltip-sm"> Edit </div>
                            </i>
                          </a>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div class="my-3">
            <button
              class="btn green-btn-revert add-plus addSp"
              id="addCount"
              type="button"
              onClick={() => addSubAccountHandler()}
            >
              <i class="i-icon"> </i> Add Sub Accounts
            </button>
          </div>
        </div>
      );
    } else if (accPrefix == "E02") {
      res = (
        <div class="inner-space screen-scroll">
          <table
            width="100%"
            cellspacing="0"
            cellpadding="0"
            style={{ marginBottom: "0!important" }}
            class="checklist-table tableSec"
            filterBy="#HistorySearchTag"
          >
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th class="second-th" width="">
                  <a class="ajaxPageSortFood asc"> Net Income ID</a>
                </th>
                <th>Accounting Period</th>
                <th>Net Income Balance</th>
                <th>Net Income Earned</th>
                <th class="hide-small"> </th>
                <th class="hide-small"> </th>
              </tr>
            </thead>
            <tbody>
              {checkArray(add_accounts_details?.subAccounts) &&
                add_accounts_details?.subAccounts.map((subAccount) => {
                  return (
                    <tr>
                      <td width="15px" class="invent-first-col">
                        <a
                          onClick={() => editSubAccountHandler(subAccount?.id)}
                        >
                          <i class="edit-icon"></i>
                        </a>
                      </td>
                      <td>{subAccount?.account_id}</td>
                      <td>{subAccount?.year}</td>
                      <td>
                        {decimalValue(
                          subAccount?.net_income,
                          2,
                          add_accounts_details?.currency
                        )}
                      </td>
                      <td>
                        (
                        {decimalValue(
                          subAccount?.income,
                          2,
                          add_accounts_details?.currency
                        )}
                        )
                      </td>
                      <td class="hide-small" width="8%">
                        {" "}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      );
    } else if (accPrefix == "E03") {
      res = (
        <div class="inner-space screen-scroll">
          <table
            width="100%"
            cellspacing="0"
            cellpadding="0"
            style={{ marginBottom: "0!important" }}
            class="checklist-table tableSec"
            filterBy="#HistorySearchTag"
          >
            <thead>
              <tr>
                <th class="second-th" width="">
                  <a class="ajaxPageSortFood asc"> Earnings ID</a>
                </th>
                <th>Earnings Year</th>
                <th>Retained Earnings Amount</th>
                <th class="hide-small"> </th>
                <th class="hide-small"> </th>
              </tr>
            </thead>
            <tbody>
              {checkArray(add_accounts_details?.accountData) &&
                add_accounts_details?.accountData.map((accDetail) => {
                  return (
                    <tr>
                      <td>{accDetail?.id}</td>
                      <td>{accDetail?.year}</td>
                      <td>
                        {decimalValue(
                          accDetail?.balance,
                          2,
                          add_accounts_details?.currency
                        )}
                      </td>
                      <td class="hide-small" width="8%">
                        {" "}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      );
    } else if (
      accPrefix == "X08" ||
      accPrefix == "X1102" ||
      accPrefix == "X1103" ||
      accPrefix == "X2100" ||
      accPrefix == "X2101"
    ) {
      res = (
        <div class="inner-space screen-scroll">
          <table
            width="100%"
            cellspacing="0"
            cellpadding="0"
            style={{ marginBottom: "0!important" }}
            class="checklist-table tableSec"
            filterBy="#HistorySearchTag"
          >
            <thead>
              <tr>
                <th width="35px"></th>
                <th class="second-th" width="">
                  <a href="#_" class="ajaxPageSortFood asc">
                    {" "}
                    Sub-Account ID
                  </a>
                </th>
                <th>Sub-Account Name</th>
                <th>Current Balance</th>
                <th>Custodian/Bank Name</th>
                <th>Account Number</th>
                <th class="hide-small"> </th>
                <th class="hide-small"> </th>
              </tr>
            </thead>
            <tbody>
              {checkArray(add_accounts_details?.subAccounts) &&
                add_accounts_details?.subAccounts.map((subAccount) => {
                  return (
                    <tr>
                      <td width="15px" class="invent-first-col">
                        {subAccount?.subaccount_count > 0 ? (
                          <a
                            onClick={() =>
                              editSubAccountHandler(subAccount?.id)
                            }
                          >
                            <i class="edit-icon"></i>
                          </a>
                        ) : (
                          <a
                            onClick={() =>
                              editSubAccountHandler(subAccount?.id)
                            }
                          >
                            <i class="edit-icon"></i>
                          </a>
                        )}
                      </td>
                      <td>{subAccount?.account_id}</td>
                      <td>{subAccount?.name}</td>
                      <td>
                        {decimalValue(
                          subAccount?.current_balance,
                          2,
                          add_accounts_details?.currency
                        )}
                      </td>
                      {subAccount?.is_bank_account == 1 ? (
                        <>
                          <td>{subAccount?.bank_name}</td>
                          <td>{subAccount?.bank_account_no}</td>
                        </>
                      ) : (
                        <>
                          <td class="hide-small"> </td>
                          <td class="hide-small"> </td>
                        </>
                      )}
                      <td class="hide-small" width="8%">
                        {" "}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      );
    } else if (accPrefix == "X2200") {
      res = (
        <div class="inner-space screen-scroll">
          <table
            width="100%"
            cellspacing="0"
            cellpadding="0"
            style={{ marginBottom: "0!important" }}
            class="checklist-table tableSec"
            filterBy="#HistorySearchTag"
          >
            <thead>
              <tr>
                <th width="35px"></th>
                <th class="second-th" width="">
                  <a href="#_" class="ajaxPageSortFood asc">
                    {" "}
                    Sub-Account ID
                  </a>
                </th>
                <th>Sub-Account Name</th>
                <th>Current Balance</th>
                <th>Custodian/Bank Name</th>
                <th>Account Number</th>
                <th class="hide-small"> </th>
                <th class="hide-small"> </th>
              </tr>
            </thead>
            <tbody>
              {checkArray(add_accounts_details?.subAccounts) &&
                add_accounts_details?.subAccounts.map((subAccount) => {
                  return (
                    <tr>
                      <td width="15px" class="invent-first-col">
                        {subAccount?.prefix == "X2318" ||
                        subAccount?.prefix == "X2202" ||
                        subAccount?.prefix == "X2203" ? (
                          <a
                            onClick={() =>
                              editSubAccountHandler(subAccount?.id)
                            }
                          >
                            <i class="edit-icon"></i>
                          </a>
                        ) : (
                          <a
                            onClick={() =>
                              editSubAccountHandler(subAccount?.id)
                            }
                          >
                            <i class="edit-icon"></i>
                          </a>
                        )}
                      </td>
                      <td>{subAccount?.account_id}</td>
                      <td>{subAccount?.name}</td>
                      <td>
                        {decimalValue(
                          subAccount?.current_balance,
                          2,
                          add_accounts_details?.currency
                        )}
                      </td>
                      {subAccount?.is_bank_account == 1 ? (
                        <>
                          <td>{subAccount?.bank_name}</td>
                          <td>{subAccount?.bank_account_no}</td>
                        </>
                      ) : (
                        <>
                          <td class="hide-small"> </td>
                          <td class="hide-small"> </td>
                        </>
                      )}
                      <td class="hide-small" width="8%">
                        {" "}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      );
    } else if (financeAcc?.finance_type_id == "1") {
      res = (
        <div class="inner-space screen-scroll">
          <div className="table-responsive">
            <table
              width="100%"
              cellspacing="0"
              cellpadding="0"
              style={{ marginBottom: "0!important" }}
              class="checklist-table tableSec"
              filterBy="#HistorySearchTag"
            >
              <thead>
                <tr>
                  {/* <th width="35px">
                  <a class="mx-a" onClick={() => addSubAccountHandler()}>
                    <img src="/img/plus-small.svg" alt="" />
                  </a>
                </th> */}
                  <th>Sub-Account ID</th>
                  <th>Sub-Account Name</th>
                  <th>Current Balance</th>
                  <th>Taxable</th>
                  <th class="hide-small"> </th>
                  <th class="hide-small"> </th>
                </tr>
              </thead>
              <tbody>
                {checkArray(add_accounts_details?.subAccounts) &&
                  add_accounts_details?.subAccounts.map((subAccount) => {
                    return (
                      <tr>
                        <td>{subAccount?.account_id}</td>
                        <td>{subAccount?.name}</td>
                        <td>
                          {decimalValue(
                            subAccount?.current_balance,
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td>{subAccount?.taxable == 1 ? "Yes" : "No"}</td>
                        <td class="hide-small" width="8%">
                          {" "}
                        </td>
                        <td class="hide-small" width="8%">
                          {" "}
                        </td>
                        <td width="15px" class="invent-first-col">
                          {subAccount?.subaccount_count > 0 ? (
                            <a
                              class="circle_icon pull-right"
                              onClick={() =>
                                editSubAccountHandler(subAccount?.id)
                              }
                            >
                              <i class="iconSprites edit-icon">
                                <div class="tooltip-sm"> Edit </div>
                              </i>
                            </a>
                          ) : (
                            <a
                              class="circle_icon pull-right"
                              onClick={() =>
                                editSubAccountHandler(subAccount?.id)
                              }
                            >
                              <i class="iconSprites edit-icon">
                                <div class="tooltip-sm"> Edit </div>
                              </i>
                            </a>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div class="my-3">
            <button
              class="btn green-btn-revert add-plus addSp"
              id="addCount"
              type="button"
              onClick={() => addSubAccountHandler()}
            >
              <i class="i-icon"> </i> Add Sub Accounts
            </button>
          </div>
        </div>
      );
    } else if (financeAcc?.finance_type_id == "2") {
      res = (
        <div class="inner-space screen-scroll">
          <div className="table-responsive">
            <table
              width="100%"
              cellspacing="0"
              cellpadding="0"
              style={{ marginBottom: "0!important" }}
              class="checklist-table tableSec"
              filterBy="#HistorySearchTag"
            >
              <thead>
                <tr>
                  <th>Sub-Account ID</th>
                  <th>Sub-Account Name</th>
                  <th>Current Balance</th>
                  <th class="hide-small"> </th>
                  <th class="hide-small"> </th>
                  <th className="action-td"> Action</th>
                </tr>
              </thead>
              <tbody>
                {checkArray(add_accounts_details?.subAccounts) &&
                  add_accounts_details?.subAccounts.map((subAccount) => {
                    return (
                      <tr>
                        <td>{subAccount?.account_id}</td>
                        <td>{subAccount?.name}</td>
                        <td>
                          {decimalValue(
                            subAccount?.current_balance,
                            2,
                            add_accounts_details?.currency
                          )}
                        </td>
                        <td class="hide-small" width="8%">
                          {" "}
                        </td>
                        <td class="hide-small" width="8%">
                          {" "}
                        </td>
                        <td className="action-td">
                          {subAccount?.subaccount_count > 0 ? (
                            <a
                              class="circle_icon pull-right"
                              onClick={() =>
                                editSubAccountHandler(subAccount?.id)
                              }
                            >
                              <i class="iconSprites edit-icon">
                                <div class="tooltip-sm"> Edit </div>
                              </i>
                            </a>
                          ) : (
                            <a
                              class="circle_icon pull-right"
                              onClick={() =>
                                editSubAccountHandler(subAccount?.id)
                              }
                            >
                              <i class="iconSprites edit-icon">
                                <div class="tooltip-sm"> Edit </div>
                              </i>
                            </a>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div class="my-3">
            <button
              class="btn green-btn-revert add-plus addSp"
              id="addCount"
              type="button"
              onClick={() => addSubAccountHandler()}
            >
              <i class="i-icon"> </i> Add Sub Accounts
            </button>
          </div>
        </div>
      );
    }
    return res;
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="top-header-sec">
              <div className="col-12 mt-3">
                <h4 className="event-alert br-btm-0">
                  Asset Details <div className="clear"></div>
                </h4>

                <div className="shadowclass mt-0">
                  <div class="row mx-0 shifts">
                    <div class="col-md-6 px-0">{getHeaderContainer()}</div>
                    <div class="clear"> </div>
                    <div class="clear"> </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="clearfix"> &nbsp; </div>

            <div
              className="accordion inv-accordion"
              id="accordionPanelsStayOpenExample"
            >
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">
                        {financeAcc?.prefix == "E02"
                          ? "Annual Net Income"
                          : `${financeAcc?.name} Sub-Accounts`}
                      </h4>
                      <h5 className="bal-h5">
                        {" "}
                        Balance:{" "}
                        {decimalValue(
                          financeAcc?.current_balance,
                          2,
                          add_accounts_details?.currency
                        )}{" "}
                      </h5>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0 top-header-sec">
                          <div className="row justify-content-between align-items-center">
                            <div className="col-md-4">
                              <div className="search-box mt-0">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="button" />
                              </div>
                            </div>
                          </div>
                          {getBodyContainer()}
                          {/* <div class="table-responsive">
                            <table class="checklist-table remove-space inventory_table">
                              <thead>
                                <tr>
                                  <th className="second-th">
                                    <a href="#_" class="">
                                      Sub-Account ID
                                    </a>
                                  </th>
                                  <th>Sub-Account Name</th>
                                  <th>Current Balance</th>
                                  <th>Taxable</th>
                                  <th></th>
                                  <th class="action-td"> Actions </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>I120001</td>
                                  <td>Excess Amount</td>
                                  <td>$0.00</td>
                                  <td>Yes</td>
                                  <td></td>
                                  <td class="align-right">
                                    <a
                                      href="#_"
                                      class="circle_icon editApFinance mx-auto float-none"
                                    >
                                      <i class="iconSprites edit-icon">
                                        <div class="tooltip-sm"> Edit </div>
                                      </i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div class="my-3">
                              <button
                                class="btn green-btn-revert add-plus addSp"
                                id="addCount"
                                type="button"
                              >
                                <i class="i-icon"> </i> Add Other Income
                                Sub-Accounts
                              </button>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Accounts;
